import React, { useState } from 'react';
import { Check, Copy, Linkedin, MessageCircle, Share2 } from 'lucide-react';

export const careerLink = (key) => `${window.location.origin}/careers${key ? `?role=${encodeURIComponent(key)}` : ''}#career`;

const ShareButtons = ({ role }) => {
  const [copied, setCopied] = useState(false);
  const url = careerLink(role?.key);
  const text = role ? `We're hiring a ${role.label} at Acre Mitra! Apply here:` : 'Build your career with Acre Mitra — open roles:';
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* blocked */ }
  };
  const native = () => navigator.share?.({ title: 'Careers at Acre Mitra', text, url }).catch(() => {});
  const id = role?.key || 'all';
  const cls = 'inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-bold transition-colors';
  return (
    <span className="inline-flex flex-wrap gap-1.5">
      <button type="button" onClick={copy} className={`${cls} border-slate-300 bg-white text-slate-700 hover:bg-slate-100`} data-testid={`career-share-copy-${id}`}>
        {copied ? <Check size={11} /> : <Copy size={11} />} {copied ? 'Copied' : 'Copy link'}
      </button>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer" className={`${cls} border-green-300 bg-green-50 text-green-800 hover:bg-green-100`} data-testid={`career-share-wa-${id}`}>
        <MessageCircle size={11} /> WhatsApp
      </a>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" className={`${cls} border-sky-300 bg-sky-50 text-sky-800 hover:bg-sky-100`} data-testid={`career-share-li-${id}`}>
        <Linkedin size={11} /> LinkedIn
      </a>
      {typeof navigator !== 'undefined' && navigator.share && (
        <button type="button" onClick={native} className={`${cls} border-emerald-300 bg-emerald-50 text-emerald-800`} data-testid={`career-share-native-${id}`}><Share2 size={11} /> Share</button>
      )}
    </span>
  );
};

export const CareerShareStrip = ({ roles }) => (
  <div className="max-w-3xl mx-auto mb-8 rounded-2xl border border-emerald-100 bg-white p-4 shadow-sm" data-testid="career-share-strip">
    <div className="flex flex-wrap items-center gap-2 mb-3">
      <Share2 size={14} className="text-emerald-700" />
      <span className="text-sm font-bold text-slate-900 flex-1">Share an opening with a friend</span>
      <ShareButtons role={null} />
    </div>
    <div className="divide-y divide-slate-100">
      {roles.map((r) => (
        <div key={r.key} className="flex flex-wrap items-center gap-2 py-2" data-testid={`career-share-role-${r.key}`}>
          <span className="text-sm text-slate-700 flex-1 min-w-[160px]">{r.label}</span>
          <ShareButtons role={r} />
        </div>
      ))}
    </div>
  </div>
);
